// src/pages/BlockedNumbers/BlockedNumbers.api.js
// HTTP helpers for Blocked Numbers (no React imports here).

import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3000',
  headers: { 'Content-Type': 'application/json' },
});

export function canonicalPhone(input) {
  const raw = String(input || '').trim().replace(/^whatsapp:/i, '');
  const only = raw.replace(/[^\d+]/g, '');
  if (!only) return '';
  return only.startsWith('+') ? only : `+${only}`;
}

export async function apiListBlocked(q = '') {
  const params = q ? { q } : {};
  const { data } = await API.get('/blocked-numbers', { params });
  return data;
}

export async function apiCreateBlocked(payload) {
  const body = {
    phone: canonicalPhone(payload.phone),
    reason: payload.reason || '',
    active: payload.active !== false,
    expiresAt: payload.expiresAt || undefined,
    createdBy: payload.createdBy || undefined,
  };
  const { data } = await API.post('/blocked-numbers', body);
  return data;
}

export async function apiUpdateBlocked(id, patch) {
  const body = { ...patch };
  if (body.phone !== undefined) body.phone = canonicalPhone(body.phone);
  const { data } = await API.patch(`/blocked-numbers/${id}`, body);
  return data;
}

export async function apiDeleteBlocked(id) {
  const { data } = await API.delete(`/blocked-numbers/${id}`);
  return data;
}
